import React, { useState } from "react";
import { Tabs, Tab, ScrollShadow } from "@heroui/react";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { GetCustomer } from "@/server-types";
import CustomerAppointmentListItem from "./CustomerAppointmentListItem/CustomerAppointmentListItem";

export default function CustomerAppointments({
  customerAppointments,
}: {
  customerAppointments: GetCustomer["response"]["customerAppointments"];
}) {
  const [selectedTab, setSelectedTab] = useState("upcoming");

  return (
    <div>
      <Tabs
        classNames={{
          tabList: "bg-white",
          tab: "border-1 border-gray-200",
          cursor: "group-data-[selected=true]:bg-gray-200 shadow-none ",
        }}
        variant="solid"
        selectedKey={selectedTab}
        onSelectionChange={(key) =>
          setSelectedTab(key?.toString() ?? "upcoming")
        }
        disableAnimation={true}
      >
        <Tab key="upcoming" title={t`Prihodnji`}>
          <AppointmentList
            customerAppointments={customerAppointments.filter(
              (customerAppointment) =>
                !customerAppointment.isCompleted &&
                !customerAppointment.isDeleted,
            )}
          />
        </Tab>
        <Tab key="completed" title={t`Pretekli`}>
          <AppointmentList
            customerAppointments={customerAppointments.filter(
              (customerAppointment) =>
                customerAppointment.isCompleted &&
                !customerAppointment.isDeleted,
            )}
          />
        </Tab>
        <Tab key="deleted" title={t`Izbrisani`}>
          <AppointmentList
            customerAppointments={customerAppointments.filter(
              (customerAppointment) => customerAppointment.isDeleted,
            )}
          />
        </Tab>
        <Tab key="all" title={t`Vsi`}>
          <AppointmentList customerAppointments={customerAppointments} />
        </Tab>
      </Tabs>
    </div>
  );
}

const AppointmentList = ({
  customerAppointments,
}: {
  customerAppointments: GetCustomer["response"]["customerAppointments"];
}) => {
  if (customerAppointments.length === 0) {
    return (
      <div className="flex items-center justify-center p-4 text-center text-sm text-gray-500">
        <Trans>Ni terminov</Trans>
      </div>
    );
  }

  return (
    <ScrollShadow className="overflow-auto md:h-[400px]">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {customerAppointments.map((customerAppointment) => (
          <CustomerAppointmentListItem
            key={customerAppointment.userAppointmentId}
            customerAppointment={customerAppointment}
          />
        ))}
      </div>
    </ScrollShadow>
  );
};
